import { render, staticRenderFns } from "./EditItemWithPart.vue?vue&type=template&id=b01ef720&scoped=true"
import script from "./EditItemWithPart.vue?vue&type=script&lang=js"
export * from "./EditItemWithPart.vue?vue&type=script&lang=js"
import style0 from "./EditItemWithPart.vue?vue&type=style&index=0&id=b01ef720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ef720",
  null
  
)

export default component.exports